import type { TransformFn } from "./Types";

export const stripGroupingWhenNotComparePrevOrGrouping: TransformFn = (res, ctx) => {
    // Some endpoints always return grouping fields. When the chart is in plain
    // mode (no compare previous and no grouping configured), strip them to keep the
    // frontend payload shape consistent with non-grouped charts.
    if (ctx.isComparePrev || ctx.groupingConfigured) return res;
    return {
        ...res,
        data: res.data.map((i) => {
            const { grouping, grouping_identifier, ...rest } = i as any;
            return rest;
        }),
    };
};

export const dropAllZeroGroupedSeries: TransformFn = (res, ctx) => {
    if (!ctx.groupingConfigured || !res.data?.length) return res;

    const seriesTotals = new Map<string, number>();

    res.data.forEach((datum: any) => {
        const seriesKey = ctx.swapGroupingAndX
            ? `${datum?.x_identifier ?? datum?.x ?? ""}`
            : `${datum?.grouping_identifier ?? datum?.grouping ?? ""}`;
        const value = Number(datum?.y ?? 0);

        if (!seriesKey.length) return;

        seriesTotals.set(seriesKey, (seriesTotals.get(seriesKey) ?? 0) + value);
    });

    const emptySeriesKeys = new Set(
        Array.from(seriesTotals.entries())
            .filter(([, total]) => total === 0)
            .map(([key]) => key),
    );

    if (!emptySeriesKeys.size) return res;

    return {
        ...res,
        data: res.data.filter((datum: any) => {
            const seriesKey = ctx.swapGroupingAndX
                ? `${datum?.x_identifier ?? datum?.x ?? ""}`
                : `${datum?.grouping_identifier ?? datum?.grouping ?? ""}`;
            return !seriesKey.length || !emptySeriesKeys.has(seriesKey);
        }),
    };
};

